/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'theme': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1004.094 321.092L762.737 79.735a68.267 68.267 0 00-96.546 0l-30.293 30.294a68.284 68.284 0 01-48.265 20.002H436.44a68.181 68.181 0 01-48.265-20.002l-30.293-30.294a68.267 68.267 0 00-96.546 0L19.962 321.092a68.267 68.267 0 000 96.546l96.546 96.547a67.84 67.84 0 0066.645 17.271c10.804-3.072 21.675 4.181 21.675 15.411V896c0 37.547 30.72 68.267 68.267 68.267H750.96c37.547 0 68.267-30.72 68.267-68.267V546.867c0-11.23 10.872-18.483 21.675-15.411a67.84 67.84 0 0066.645-17.271l96.546-96.547a68.267 68.267 0 000-96.546z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/theme.js